export default __webpack_public_path__ + "static/deliver-43cf83367f0bdf7ac366564941b68921.gif";